import { render, staticRenderFns } from "./TermsViewModal.vue?vue&type=template&id=5b908d2b&"
import script from "./TermsViewModal.vue?vue&type=script&lang=js&"
export * from "./TermsViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports